// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-severe-incident-report.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-severe-incident-report',
  title:
    'Operate the CRA Art. 14(3) reporting clock for severe incidents impacting product security (24h / 72h / 14d)',
  description:
    "Confirm that the manufacturer has the operational capability to report severe incidents that have an impact on the security of its products with digital elements to ENISA and the relevant CSIRT under CRA Art. 14(3) using the same cadence as actively exploited vulnerabilities: an early warning within 24 hours of becoming aware, a follow-up notification within 72 hours including a preliminary assessment of the incident and its impact, and a final report within one month of submitting the notification under 14(3)(b). The incident reporting workflow is integrated with the organisation's general incident response so the responder can distinguish the CRA route from generic regulatory routes (e.g. NIS2 Art. 23, GDPR Art. 33). Review the incident classification criteria, the reporting playbook, and the submission log.",
  category: 'incidents',
  scfIds: ['SCF-INC-002', 'SCF-INC-003', 'SCF-INC-006'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Severe-incident reporting playbook is published' },
    { type: 'document-approved', description: 'Playbook has been approved' },
    { type: 'document-within-sla', description: 'Playbook review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
